import { api } from "./api";

export const busList = async (addUrl = "") => {
  return await api.get(`/bus/list?${addUrl}`);
};

export const busAdd = async (data) => {
  return await api.post("/bus/add", data);
};

export const busUpdate = async (data) => {
  return await api.post("/bus/update", data);
};

export const busDelete = async (id) => {
  return await api.post(`/bus/delete/`, { id });
};

export const busStatusUpdate = async (id) => {
  return await api.post("/bus/status/update", { id });
};

export const busStopsList = async (url = "") => {
  return await api.get(`/bus/stops/list?${url}`);
};

export const busStopAdd = async (data) => {
  return await api.post("/bus/stop/add", data);
};

export const busStudentUpdate = async (data) => {
  return await api.post("/bus-student/update", data);
};

export const busStopUpdate = async (data) => {
  return await api.post("/bus/stop/update", data);
};

export const busStopDelete = async (data) => {
  return await api.post(`/bus/stop/delete`, data);
};

export const studentBusEnroll = async (data) => {
  return await api.post(`/bus/student/add`, data);
};

export const busStudentList = async (addUrl = ``) => {
  return await api.get(`/bus/students/list?${addUrl}`);
};

export const busStopImport = async (data) => {
  return await api.post(`/bus/stop/import`, data);
};

export const busStudentsList = async (addUrl = "") => {
  let url = `/bus/students/list?${addUrl}`;
  return await api.get(url);
};

export const busStudentView = async (id) => {
  return await api.get(`/bus/students/view?id=${id}`);
};

export const busReport = async (addUrl = "") => {
  let url = `/bus/report?${addUrl}`;
  return await api.get(url);
};
export const busEndStudent = async (addUrl = "") => {
  let url = `/bus/end/student?${addUrl}`;
  return await api.get(url);
};

export const fetchBusListWithLocation = async () => {
  return await api.get(`/bus/list/with-location`);
};

export const fetchBusLocations = async (id) => {
  return await api.get(`/bus/locations?bus_id=${id}`);
};

export const busStudentsWithFees = (addUrl = "") => {
  return api.get(`/bus/students/fees?${addUrl}`);
};

export const busStudentBulkFeeUpdate = (data) => {
  return api.post("/bus/student/fee/update-bulk", data);
};
